/**
 * Clean variant links (SMI + product page)
 * - Removes ?variant= from the address bar (without breaking selected variant)
 * - Prevents SMI cards from leaving ?variant= on their <a> links after swatch click
 */

(function () {
    function stripVariantFromUrl() {
    try {
      const url = new URL(window.location.href);

      // Params die we niet in de adresbalk willen tonen
      const removeParams = [
        "variant",
        "pr_prod_strat",
        "pr_rec_id",
        "pr_rec_pid",
        "pr_ref_pid",
        "pr_seq",
      ];

      let changed = false;
      removeParams.forEach((p) => {
        if (url.searchParams.has(p)) {
          url.searchParams.delete(p);
          changed = true;
        }
      });

      if (!changed) return;

      // Rebuild clean URL (keep other params if any)
      const params = url.searchParams.toString();
      const clean = url.pathname + (params ? `?${params}` : "") + url.hash;

      window.history.replaceState({}, "", clean);
    } catch (e) {
      // ignore
    }
  }


  function stripVariantFromCardLinks(cardEl) {
    if (!cardEl) return;
    cardEl.querySelectorAll("a[href*='?variant=']").forEach((link) => {
      const href = link.getAttribute("href");
      if (!href) return;
      link.setAttribute("href", href.split("?")[0]); // keeps it simple & safe
    });
  }

  // 1) Always clean the address bar on load (works when landing on ?variant= links)
  document.addEventListener("DOMContentLoaded", function () {
    stripVariantFromUrl();

    // 2) If SMI rewrites links after a swatch click, clean those links immediately
    document.body.addEventListener("click", function (event) {
      const variantItem = event.target.closest(".smi-variants__item");
      if (!variantItem) return;

      const card = variantItem.closest(".smi-product-card");
      if (!card) return;

      // Let SMI run first, then clean
      setTimeout(() => {
        stripVariantFromCardLinks(card);
        stripVariantFromUrl(); // just in case SMI also touched the address bar
      }, 0);
    });

    // 3) Extra safety: if the theme updates URL on variant change, clean again shortly after
    document.body.addEventListener("change", function (event) {
      // catches common variant selectors
      const isVariantSelector =
        event.target.matches("[name='id']") ||
        event.target.closest("variant-selects") ||
        event.target.closest("variant-radios");

      if (!isVariantSelector) return;
      setTimeout(stripVariantFromUrl, 0);
    });
  });
})();
